import axiosInstance from '@/utils/api.js'

var state = {
  telephoneNumbr: []
}

var getters = {
  TELEPHONE_NUMBER: (state) => {
    return state.telephoneNumbr
  }
}

var mutations = {
  SET_TELEPHONE_NUMBER: (state, payload) => {
    state.telephoneNumbr = payload
  }
}

var actions = {
  GET_TELEPHONE_NUMBERS: async (context, payload) => {
    let result = await axiosInstance.get('/users/tel_numbers')
    if (result.status === 200) {
      context.commit('SET_TELEPHONE_NUMBER', result.data)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/users/telephoneNumbr.js